import { Modal } from '@ethsign/ui';

import { ColorFileIcon } from '../Icons';

export const WithoutPasswordModal = ({
  onConfirm,
  onCancel,
  open,
  onOpenChange
}: {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  onConfirm: () => void;
  onCancel: () => void;
}) => {
  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      onConfirm={onCancel}
      onCancel={onConfirm}
      cancelText={'Continue'}
      confirmText={'Set Password'}
      confirmButtonProps={{
        variant: 'primary'
      }}
    >
      <div className="flex items-center flex-col justify-center">
        <ColorFileIcon />
        <div className="text-lg font-medium text-gray-900 mt-[20px]">Save without password?</div>
        <div className="text-sm text-gray-500 mt-[8px] text-center">
          EthSign store all contracts on chain through decentralized storage platform. Sending contract without password
          will make the content accessible on chain. Are you sure you want to continue without password?
        </div>
      </div>
    </Modal>
  );
};
